import { useState, useRef, useMemo, useEffect } from 'react';
import { PrimaryButton } from '@client/new/components/button';
import {
  ValidationMessage,
  validateVideo,
} from '../videos/components/editVideo.helpers';
import { EditVideoStatus } from '../videos/components/EditVideoStatus';
import { allowedVideoTypes } from '../videos/videos.constants';
import { CircularProgress } from '@mui/material';
import { VideoType } from '../videos/videos.domain';

type MediaFileValidationProps = {
  media: File;
  videoType: VideoType;
  addVideo: (file: File) => void;
  onValidationSuccess: () => void;
};

export const MediaFileValidation = (p: MediaFileValidationProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isValidating, setValidating] = useState<boolean>(false);
  const [validationMessage, setValidationMessage] =
    useState<ValidationMessage>();

  useEffect(() => {
    if (videoRef.current) {
      setValidating(true);
      videoRef.current.addEventListener('loadedmetadata', function () {
        if (videoRef.current) {
          const message = validateVideo({
            duration: videoRef.current.duration,
            fileSize: p.media.size,
            videoHeight: videoRef.current.videoHeight,
            videoWidth: videoRef.current.videoWidth,
            videoType: p.videoType,
          });
          if (!message) {
            p.onValidationSuccess();
          } else {
            setValidationMessage(message);
            setValidating(false);
          }
        }
      });
    }
  }, [p.media]);

  const videoSrc = useMemo(
    () => (p.media ? URL.createObjectURL(p.media) : ''),
    [p.media],
  );

  return (
    <div>
      <>
        <EditVideoStatus validationMessage={validationMessage} />
        <div className="flex justify-center bg-black">
          <video
            controls={true}
            ref={videoRef}
            src={videoSrc}
            className="w-full h-[410px]"
          />
        </div>
        {isValidating ? (
          <div className="w-full flex justify-center items-center">
            <CircularProgress />
          </div>
        ) : (
          <div className="flex pt-[24px] justify-end">
            <>
              <PrimaryButton onClick={() => inputRef.current?.click()}>
                Choose new video
              </PrimaryButton>

              <input
                type="file"
                accept={allowedVideoTypes.join(', ')}
                ref={inputRef}
                onChange={(ev) =>
                  ev.target.files && p.addVideo(ev.target.files[0])
                }
                multiple={false}
                hidden
              />
            </>
          </div>
        )}
      </>
    </div>
  );
};
